import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from './store';

/**
 * Guards the authed dashboard. Two layers:
 *   - no token  → bounce to /login
 *   - must change password and you're not already on /change-password → push there
 */
export function ProtectedRoute() {
  const token = useAuthStore((s) => s.token);
  const mustChangePassword = useAuthStore((s) => s.mustChangePassword);
  const location = useLocation();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (mustChangePassword && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return <Outlet />;
}
